// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1MXuK","assignButton":"CreateEditEquipmentSchedule_assignButton__36xV3"};